var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0.486328C6.50301 0.486328 3.65771 3.33163 3.65771 6.82859C3.65771 12.4233 9.45494 19.0965 9.70189 19.378C9.77721 19.464 9.88582 19.5131 9.99998 19.5131C10.1229 19.5048 10.2247 19.4628 10.3 19.3756C10.547 19.0894 16.3422 12.3039 16.3422 6.82859C16.3422 3.33163 13.4969 0.486328 9.99998 0.486328ZM10 9.56409C11.3689 9.56409 12.4787 8.45436 12.4787 7.08545C12.4787 5.71654 11.3689 4.60681 10 4.60681C8.63112 4.60681 7.52139 5.71654 7.52139 7.08545C7.52139 8.45436 8.63112 9.56409 10 9.56409Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0.486328C6.50301 0.486328 3.65771 3.33163 3.65771 6.82859C3.65771 12.4233 9.45494 19.0965 9.70189 19.378C9.77721 19.464 9.88582 19.5131 9.99998 19.5131C10.1229 19.5048 10.2247 19.4628 10.3 19.3756C10.547 19.0894 16.3422 12.3039 16.3422 6.82859C16.3422 3.33163 13.4969 0.486328 9.99998 0.486328ZM10 9.56409C11.3689 9.56409 12.4787 8.45436 12.4787 7.08545C12.4787 5.71654 11.3689 4.60681 10 4.60681C8.63112 4.60681 7.52139 5.71654 7.52139 7.08545C7.52139 8.45436 8.63112 9.56409 10 9.56409Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0.486328C6.50301 0.486328 3.65771 3.33163 3.65771 6.82859C3.65771 12.4233 9.45494 19.0965 9.70189 19.378C9.77721 19.464 9.88582 19.5131 9.99998 19.5131C10.1229 19.5048 10.2247 19.4628 10.3 19.3756C10.547 19.0894 16.3422 12.3039 16.3422 6.82859C16.3422 3.33163 13.4969 0.486328 9.99998 0.486328ZM10 9.56409C11.3689 9.56409 12.4787 8.45436 12.4787 7.08545C12.4787 5.71654 11.3689 4.60681 10 4.60681C8.63112 4.60681 7.52139 5.71654 7.52139 7.08545C7.52139 8.45436 8.63112 9.56409 10 9.56409Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.08ecbcdccd066b0dd9ba469a58b8c36b.svg";
export { ForwardRef as ReactComponent };